/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Card } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Cards<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags cards
   * @name DeleteCards
   * @summary 登録されたすべてのカード情報を削除する
   * @request DELETE:/cards
   */
  deleteCards = (params: RequestParams = {}) =>
    this.request<any, void>({
      path: `/cards`,
      method: "DELETE",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags cards
   * @name GetCardsDefault
   * @summary デフォルトのカード情報を取得する
   * @request GET:/cards/default
   */
  getCardsDefault = (params: RequestParams = {}) =>
    this.request<Card, void>({
      path: `/cards/default`,
      method: "GET",
      type: ContentType.UrlEncoded,
      ...params,
    });
  /**
   * No description
   *
   * @tags cards
   * @name PostCards
   * @summary 顧客にカードを追加する
   * @request POST:/cards
   */
  postCards = (
    data: {
      /** PAYJPカードトークン */
      payjp_card_token: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<Card, void>({
      path: `/cards`,
      method: "POST",
      body: data,
      type: ContentType.UrlEncoded,
      ...params,
    });
}
